import { render, staticRenderFns } from "./ExpressFeePromotionList.vue?vue&type=template&id=7645dba6&scoped=true&"
import script from "./ExpressFeePromotionList.vue?vue&type=script&lang=js&"
export * from "./ExpressFeePromotionList.vue?vue&type=script&lang=js&"
import style0 from "./ExpressFeePromotionList.vue?vue&type=style&index=0&id=7645dba6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7645dba6",
  null
  
)

export default component.exports